import React from "react";

import { Box, Paper, Stack, Typography } from "@mui/material";
import { useStyles } from "./style.js";
import SouthIcon from "@mui/icons-material/South";
import { useNotification } from "../../../Hooks/notification.js";
import CustomPagination from "../../../common/Pagination/index.js";
import usePagination from "../../../common/usePagination/index.js";
import { useState } from "react";
import { useCallback } from "react";
import CustomLoader from "../../../components/Loader/index.js";
import { getData } from "../../../Utils/notification.js";
import Avatar from "../../../assets/images/Dashboard/avatar.png";

const Notification = () => {
  const classes = useStyles();
  const [status, setStatus] = React.useState("");
  const [page, setPage] = useState(1);
  const [PerPage, setPerPage] = useState(10);
  const [offset, setOffset] = useState(0);
  const {
    idFaculty,
    getStaffNotificationAction,
    notificationData,
    loading,
    activeId,
    readStaffNotificationAction,
    resetActiveIdAction,
  } = useNotification();

  React.useEffect(() => {
    resetActiveIdAction();
  }, []);

  const handlePage = (e) => {
    setPerPage(e.target.value);
  };

  const count =
    notificationData &&
    Math.ceil(
      notificationData?.totalNoOfRecordsForParticularStaff?.totalNoOfRecords /
        PerPage
    );
  const _DATA = usePagination(notificationData?.staffNotification, PerPage);

  const handleChange = useCallback(
    (e, p) => {
      setPage(p);
      setOffset(p * PerPage - PerPage);
      _DATA.jump(p);
    },
    [PerPage, page]
  );

  React.useEffect(() => {
    getStaffNotificationAction({
      idFaculty: idFaculty,
      limit: PerPage,
      offset: offset,
    });
  }, [PerPage, offset]);

  return (
    <Stack className={classes.notifi}>
      <div>
        <Stack
          sx={{
            flexDirection: "row",
            justifyContent: "space-between",
            width: "80%",
          }}
        >
          <Stack>
            <Paper
              sx={{
                width: "350px",
                borderRadius: "20px",
                background: status === "unread" && "#E4F2FF",
              }}
              elevation={3}
            >
              <Stack
                sx={{
                  p: 4,
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "row",
                  cursor: "pointer",
                }}
                role="button"
                onClick={() => {
                  setStatus("unread");
                }}
              >
                <p>Unread </p>
                <SouthIcon style={{ marginLeft: "200px" }} />
              </Stack>
            </Paper>
          </Stack>
          <Stack>
            <Paper
              sx={{
                width: "350px",
                borderRadius: "20px",
                background: status === "read" && "#E4F2FF",
              }}
              elevation={3}
            >
              <Stack
                sx={{
                  p: 4,
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "row",
                  cursor: "pointer",
                }}
                role="button"
                onClick={() => setStatus("read")}
              >
                <p>Read </p>
                <SouthIcon style={{ marginLeft: "200px" }} />
              </Stack>
            </Paper>
          </Stack>
        </Stack>
      </div>
      <div>
        <Stack>
          <Box sx={{ width: "70%", marginTop: "70px" }}>
            <Paper
              sx={{
                width: "100%",
                borderRadius: "20px",
                filter: "drop-shadow(0px 4px 40px rgba(0, 0, 0, 0.08))",
                boxShadow: "none",
              }}
            >
              <Stack sx={{ p: 2 }}>
                {getData(_DATA.currentData(), status)?.length > 0
                  ? getData(_DATA.currentData(), status)?.map((data, index) => {
                      return (
                        <Stack
                          key={index}
                          sx={{
                            justifyContent: "space-between",
                            flexDirection: "row ",
                            alignItems: "center",
                            p: 4,
                          }}
                        >
                          <div className={classes.notifiLeft}>
                            <div className={classes.img_holder}>
                              <img src={Avatar} alt="no img" />
                            </div>
                            <div style={{ marginLeft: "70px" }}>
                              <p className={classes.gaps}>
                                {data.notification}
                              </p>
                              <p className={classes.gap}>
                                {data.notificationDate}
                              </p>
                            </div>
                          </div>
                          <div>
                            {loading && activeId === data.id ? (
                              <CustomLoader />
                            ) : (
                              <Typography
                                sx={{ fontFamily: "inter" }}
                                role="button"
                                onClick={() => {
                                  readStaffNotificationAction(data.id);
                                }}
                              >
                                {data.status === "unread" ? "Mark as read" : ""}
                              </Typography>
                            )}
                          </div>
                        </Stack>
                      );
                    })
                  : "No Data"}
                {getData(_DATA.currentData(), status)?.length > 10 && (
                  <CustomPagination
                    count={count}
                    page={page}
                    onPageChange={handleChange}
                    handlePage={handlePage}
                    perPage={PerPage}
                  />
                )}
              </Stack>
            </Paper>
          </Box>
        </Stack>
      </div>
    </Stack>
  );
};

export default Notification;
